module.exports = __webpack_public_path__ + "static/about-investition4-3efc8b6853f70a612ef63ffb8473558a.jpg";